module.exports = __webpack_public_path__ + "img/icon_11.82fb699b.png";